import React, { useEffect, useState, useRef } from "react";
import Header from "../../../Componets/Header";
import { useLocation } from "react-router-dom";
import toast from "react-hot-toast";
import moment from "moment";
import Loadercomponent from "../../../Componets/Loader";
import { get_transfer_report } from "../../../Controllers/Dashboard/Dashboard";
import ReactToPrint from "react-to-print";
import { Button } from "antd";
import { PrinterOutlined } from "@ant-design/icons";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { registerCairoFont } from "../cairo-font";
import ScrollWrapper from "../../../Componets/ScrollWrapper";

const TransferReports = () => {
  let location = useLocation();
  let componentRef = useRef();

  const [loader, setLoader] = useState(false);
  const [body, setBody] = useState([]);
  const [role, setRole] = useState("");

  const headers = {
    name: "Transfer Reports",
    components: [
      {
        type: "search",
        name: "search",
        placeholder: "Search",
        value: "",
      },
      {
        type: "select",
        name: "sort",
        placeholder: "Sort",
        allowClear: true,
        showSearch: false,
        filterOption: true,
        value: null,
        options: [
          { value: 0, label: "Price (Low-High)" },
          { value: 1, label: "Price (High-Low)" },
        ],
      },
      {
        type: "filter",
        name: "supplier",
        allowClear: true,
        showSearch: true,
        filterOption: false,
        placeholder: "Branches",
        api: "get-all-sub-branches",
        value: null,
        options: null,
      },
      {
        type: "filter",
        name: "branch",
        allowClear: true,
        showSearch: true,
        filterOption: false,
        placeholder: "Branch",
        api: "get-all-branches",
        value: null,
        options: null,
      },
      {
        type: "filter",
        name: "status",
        placeholder: "Status",
        value: null,
        allowClear: true,
        showSearch: false,
        filterOption: true,
        options: [
          { value: 0, label: "Inactive" },
          { value: 1, label: "Active" },
        ],
      },
      {
        type: "range",
        name: "date",
        value: {
          start: "",
          end: "",
        },
      },
      {
        type: "range",
        name: "due_date",
        value: {
          start: "",
          end: "",
        },
      },
    ],
    navigate: {
      tabs: [
        {
          name: "Reports",
          path: "/app/reports",
        },
        {
          name: "Transfer",
          path: ""
        }
      ],
      total: [
        { value: 0, label: "Total" },
        { value: 0, label: "Active" },
        { value: 0, label: "Inactive" },
      ],
    },
  };

  const [header, setHeader] = useState(headers);

  const formdata = (data) => {
    fetchData(data);
  };

  const fetchData = async (tabledata) => {
    try {
      setLoader(true);

      const data = {
        search: tabledata?.search,
        sort: tabledata?.sort,
        supplier: tabledata?.supplier,
        branch: tabledata?.branch,
        status: tabledata?.status,
        date: tabledata?.date,
        due_date: tabledata?.due_date,
      };

      const products = await get_transfer_report(data);

      if (products?.status) {
        setBody(products?.data?.reports || []);
        setRole(products?.data?.role)
        setLoader(false);
      } else {
        toast?.error(products?.message);
        setLoader(false);
      }
    } catch (errors) {
      toast?.error(errors?.message);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const downloadCSV = () => {
    try {
      if (!body || body.length === 0) {
        toast.error("No data available to download");
        return;
      }

      const mainHeaders = [
        "Transfer Number",
        "From Branch",
        "To Branch",
        "Transferred Total",
        "Received Total",
        "Difference",
        "Status"
      ];

      const detailHeaders = [
        "S.No",
        "Product",
        "Unit",
        "Transferred Qty",
        "Transferred Price",
        "Transferred Total",
        "Received Qty",
        "Received Price",
        "Received Total",
        "Qty Diff",
        "Total Diff"
      ];

      let csvContent = [mainHeaders.join(",")];

      body.forEach((transfer, transferIndex) => {
        const mainRow = [
          `#TR-${transfer?.transfer?.number || ""}`,
          `"${transfer?.transfer?.branch?.name || ""}"`,
          `"${transfer?.transfer?.supplier?.name || ""}"`,
          transfer?.summary?.transferred_total?.toFixed(3) || "0.000",
          transfer?.summary?.received_total?.toFixed(3) || "0.000",
          transfer?.summary?.total_difference?.toFixed(3) || "0.000",
          transfer?.transfer?.received ? "Received" : "Pending"
        ];
        csvContent.push(mainRow.join(","));

        csvContent.push(detailHeaders.join(","));

        transfer?.details?.forEach((detail, detailIndex) => {
          const detailRow = [
            detailIndex + 1,
            `"${detail?.product?.name || "N/A"}"`,
            `"${detail?.unit?.name || "N/A"}"`,
            detail?.transferred_quantity || 0,
            detail?.transferred_price?.toFixed(3) || "0.000",
            detail?.transferred_total?.toFixed(3) || "0.000",
            detail?.received_quantity || 0,
            detail?.received_price?.toFixed(3) || "0.000",
            detail?.received_total?.toFixed(3) || "0.000",
            detail?.difference_quantity || 0,
            detail?.difference_total?.toFixed(3) || "0.000"
          ];
          csvContent.push(detailRow.join(","));
        });

        if (transferIndex < body.length - 1) {
          csvContent.push("");
        }
      });

      const totalTransferred = body?.reduce((acc, val) => acc + (val?.summary?.transferred_total || 0), 0)?.toFixed(3) || "0.000";
      const totalReceived = body?.reduce((acc, val) => acc + (val?.summary?.received_total || 0), 0)?.toFixed(3) || "0.000";
      const totalDifference = body?.reduce((acc, val) => acc + (val?.summary?.total_difference || 0), 0)?.toFixed(3) || "0.000";

      csvContent.push("");
      csvContent.push(["", "", "", "GRAND TOTAL", totalTransferred, totalReceived, totalDifference].join(","));

      const encoder = new TextEncoder();
      const encodedContent = encoder.encode('\uFEFF' + csvContent);

      const blob = new Blob([encodedContent], { type: 'text/csv;charset=utf-8' });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);

      link.setAttribute("href", url);
      link.setAttribute("download", `Transfer_Reports_${new Date().toLocaleDateString().replace(/\//g, '_')}.csv`);
      link.style.visibility = 'hidden';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

    } catch (error) {
      console.error("Error generating CSV:", error);
      toast.error("Failed to generate CSV file");
    }
  };

  const downloadPDF = () => {
    try {
      if (!body || body.length === 0) {
        toast.error("No data available to download");
        return;
      }

      const doc = new jsPDF({
        orientation: "landscape",
        unit: "mm",
        format: "a4",
      });

      registerCairoFont(doc);
      const pageWidth = doc.internal.pageSize.getWidth();

      doc.setFont("Cairo-Bold", "bold");


      let startY = 20;

      body.forEach((transfer, transferIndex) => {
        if (transferIndex > 0) {
          doc.addPage();
          startY = 20;
        }

        doc.setFontSize(16);
        doc.text(`Transfer Report - #TR-${transfer?.transfer?.number || ""}`, pageWidth / 2, startY, { align: "center" });

        doc.setFontSize(10);
        doc.text(`From: ${transfer?.transfer?.branch?.name || ""}`, 14, startY + 8);
        doc.text(`To: ${transfer?.transfer?.supplier?.name || ""}`, 14, startY + 16);
        doc.text(`Status: ${transfer?.transfer?.received ? "Received" : "Pending"}`, 14, startY + 24);

        startY += 35;

        const summaryHeaders = [["Description", "Amount"]];
        const summaryData = [
          ["Transferred Total", transfer?.summary?.transferred_total?.toFixed(3) || "0.000"],
          ["Received Total", transfer?.summary?.received_total?.toFixed(3) || "0.000"],
          ["Difference", transfer?.summary?.total_difference?.toFixed(3) || "0.000"]
        ];

        autoTable(doc, {
          startY: startY,
          head: summaryHeaders,
          body: summaryData,
          theme: 'grid',
          styles: {
            font: "Cairo",
            textColor: [0, 0, 0],
            lineColor: [7, 181, 83],
            lineWidth: 0.2
          },
          headStyles: {
            font: "Cairo",
            fontStyle: "bold",
            fillColor: false,
            lineColor: [7, 181, 83],
            lineWidth: 0.6
          },
          margin: { left: 14 }
        });

        startY = doc.lastAutoTable.finalY + 15;

        const detailHeaders = [
          "S.No",
          "Product",
          "Unit",
          "Transferred Qty",
          "Transferred Price",
          "Transferred Total",
          "Received Qty",
          "Received Price",
          "Received Total",
          "Qty Diff",
          "Total Diff"
        ];

        const detailRows = transfer?.details?.map((detail, index) => [
          index + 1,
          detail?.product?.name || "N/A",
          detail?.unit?.name || "N/A",
          detail?.transferred_quantity || 0,
          detail?.transferred_price?.toFixed(3) || "0.000",
          detail?.transferred_total?.toFixed(3) || "0.000",
          detail?.received_quantity || 0,
          detail?.received_price?.toFixed(3) || "0.000",
          detail?.received_total?.toFixed(3) || "0.000",
          detail?.difference_quantity || 0,
          detail?.difference_total?.toFixed(3) || "0.000"
        ]) || [];

        autoTable(doc, {
          startY: startY,
          head: [detailHeaders],
          body: detailRows,
          theme: 'grid',

          margin: { left: 14 },

          styles: {
            font: "Cairo",
            textColor: [0, 0, 0],
            lineColor: [7, 181, 83],
            lineWidth: 0.2,
            fontSize: 7,
            cellPadding: 2
          },
          headStyles: {
            font: "Cairo",
            fontStyle: "bold",
            fillColor: false,
            lineColor: [7, 181, 83],
            lineWidth: 0.6
          },
        });

        startY = doc.lastAutoTable.finalY + 10;
      });

      const totalTransferred = body?.reduce((acc, val) => acc + (val?.summary?.transferred_total || 0), 0)?.toFixed(3) || "0.000";
      const totalReceived = body?.reduce((acc, val) => acc + (val?.summary?.received_total || 0), 0)?.toFixed(3) || "0.000";
      const totalDifference = body?.reduce((acc, val) => acc + (val?.summary?.total_difference || 0), 0)?.toFixed(3) || "0.000";

      doc.setFontSize(12);
      doc.text(`Grand Totals - Transferred: ${totalTransferred} | Received: ${totalReceived} | Difference: ${totalDifference}`, 14, doc.internal.pageSize.height - 20);

      const formattedDate = new Date().toLocaleDateString("en-GB");
      doc.save(`Transfer_Reports_${formattedDate}.pdf`);

    } catch (error) {
      console.error("Error generating PDF:", error);
      toast.error("Failed to generate PDF file");
    }
  };

  useEffect(() => {
    if (!role) return;

    let updatedHeader = { ...headers };

    if (role !== "SUPERADMIN") {
      updatedHeader.components = updatedHeader.components.filter(
        (item) => item.name !== "branch"
      );
    }

    setHeader(updatedHeader);
  }, [role]);

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>

        <div className="mt-4">
          <div className="text-right flex gap-3 justify-end">
            <Button
              className="text-medium form-save-button"
              type="primary"
              onClick={downloadCSV}
            >
              Download CSV
            </Button>

            <ReactToPrint
              trigger={() => (

                <Button
                  className="text-medium form-save-button"
                  type="primary"
                >
                  Download PDF
                </Button>
              )}
              content={() => componentRef}
              pageStyle={`
                                  @page {
                                    size: landscape;
                                    margin: 10mm;
                                  }
                    
                                  @media print {
                                    tfoot {
                                      position: static !important;
                                      bottom: auto !important;
                                    }
                                    thead { 
                                      display: table-header-group !important;
                                    }
                                    tfoot {
                                      display: table-row-group !important;
                                    }
                                  }
                    
                                    table {
                                    border-collapse: collapse;
                                    width: 100%;
                                  }
                                  th, td {
                                    border: 1px solid #ddd;
                                    padding: 6px;
                                  }
                                  th {
                                    background-color: #f4f4f4;
                                  }
                                `}
            />

          </div>
        </div>

        <ScrollWrapper>
          <div
            className="max-h-[70vh] overflow-y-auto scrollbar-hide remove-scroll-limit"
            ref={(el) => (componentRef = el)}
          >
            <table className="w-full bg-white border-collapse">
              <thead className="text-gray-500 bg-gray-100 sticky top-0 z-10">
                <tr className="p-2">
                  <th className="border p-2 text-sm font-normal text-left">
                    Transfer
                  </th>
                  <th className="border p-2 text-sm font-normal">From Branch</th>
                  <th className="border p-2 text-sm font-normal">To Branch</th>
                  <th className="border p-2 text-sm font-normal">Transferred Total</th>
                  <th className="border p-2 text-sm font-normal">Received Total</th>
                  <th className="border p-2 text-sm font-normal">Difference</th>
                  <th className="border p-2 text-sm font-normal">Status</th>
                </tr>
              </thead>
              <tbody className="">
                {body?.map((value, index) => (
                  <React.Fragment key={index}>
                    <tr className="bg-white">
                      <td className="border p-2 text-sm text-medium text-left">
                        #TR-{value?.transfer?.number}
                      </td>
                      <td className="border p-2 text-sm text-medium text-center">
                        {value?.transfer?.branch?.name}
                      </td>
                      <td className="border p-2 text-sm text-medium text-center">
                        {value?.transfer?.supplier?.name}
                      </td>
                      <td className="border p-2 text-sm text-medium text-center">
                        {value?.summary?.transferred_total?.toFixed?.(3)}
                      </td>
                      <td className="border p-2 text-sm text-medium text-center">
                        {value?.summary?.received_total?.toFixed?.(3)}
                      </td>
                      <td className={`border p-2 text-sm text-medium text-center ${value?.summary?.total_difference < 0 ? 'text-red-600' :
                        value?.summary?.total_difference > 0 ? 'text-green-600' : ''
                        }`}>
                        {value?.summary?.total_difference?.toFixed?.(3)}
                      </td>
                      <td className="border p-2 text-sm text-medium text-center">
                        {value?.transfer?.received ? 'Received' : 'Pending'}
                      </td>
                    </tr>
                    <tr>
                      <td colSpan={8} className="pt-2 pb-2">
                        <table className="w-full border text-gray-500 bg-gray-50">
                          <thead>
                            <tr className="font-normal">
                              <th className="border p-1 text-xs font-normal">S.NO</th>
                              <th className="border p-1 text-xs font-normal">PRODUCT</th>
                              <th className="border p-1 text-xs font-normal">UNIT</th>
                              <th className="border p-1 text-xs font-normal">TRANSFERRED QTY</th>
                              <th className="border p-1 text-xs font-normal">TRANSFERRED PRICE</th>
                              <th className="border p-1 text-xs font-normal">TRANSFERRED TOTAL</th>
                              <th className="border p-1 text-xs font-normal">RECEIVED QTY</th>
                              <th className="border p-1 text-xs font-normal">RECEIVED PRICE</th>
                              <th className="border p-1 text-xs font-normal">RECEIVED TOTAL</th>
                              <th className="border p-1 text-xs font-normal">QTY DIFF</th>
                              <th className="border p-1 text-xs font-normal">TOTAL DIFF</th>
                            </tr>
                          </thead>
                          <tbody className="text-gray-500">
                            {value?.details?.map((v, i) => (
                              <tr key={i} className="text-xs">
                                <td className="border p-1 text-center">{i + 1}</td>
                                <td className="border p-1 text-center">
                                  {v?.product?.name || 'N/A'}
                                </td>
                                <td className="border p-1 text-center">
                                  {v?.unit?.name || 'N/A'}
                                </td>
                                <td className="border p-1 text-center">
                                  {v?.transferred_quantity}
                                </td>
                                <td className="border p-1 text-center">
                                  {v?.transferred_price?.toFixed?.(3)}
                                </td>
                                <td className="border p-1 text-center">
                                  {v?.transferred_total?.toFixed?.(3)}
                                </td>
                                <td className="border p-1 text-center">
                                  {v?.received_quantity}
                                </td>
                                <td className="border p-1 text-center">
                                  {v?.received_price?.toFixed?.(3)}
                                </td>
                                <td className="border p-1 text-center">
                                  {v?.received_total?.toFixed?.(3)}
                                </td>
                                <td className={`border p-1 text-center ${v?.difference_quantity < 0 ? 'text-red-600' :
                                  v?.difference_quantity > 0 ? 'text-green-600' : ''
                                  }`}>
                                  {v?.difference_quantity}
                                </td>
                                <td className={`border p-1 text-center ${v?.difference_total < 0 ? 'text-red-600' :
                                  v?.difference_total > 0 ? 'text-green-600' : ''
                                  }`}>
                                  {v?.difference_total?.toFixed?.(3)}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </React.Fragment>
                ))}
              </tbody>
              <tfoot className="sticky bottom-0 bg-white z-10">
                <tr className="font-semibold bg-gray-100 text-sm">
                  <td className="border p-2 font-normal text-medium" colSpan={4}>
                    Total
                  </td>
                  <td className="border p-2 font-normal text-medium">
                    {body?.reduce((acc, val) => acc + (val?.summary?.transferred_total || 0), 0)?.toFixed?.(3)}
                  </td>
                  <td className="border p-2 font-normal text-medium">
                    {body?.reduce((acc, val) => acc + (val?.summary?.received_total || 0), 0)?.toFixed?.(3)}
                  </td>
                  <td className={`border p-2 font-normal text-medium ${body?.reduce((acc, val) => acc + (val?.summary?.total_difference || 0), 0) < 0 ? 'text-red-600' :
                    body?.reduce((acc, val) => acc + (val?.summary?.total_difference || 0), 0) > 0 ? 'text-green-600' : ''
                    }`}>
                    {body?.reduce((acc, val) => acc + (val?.summary?.total_difference || 0), 0)?.toFixed?.(3)}
                  </td>
                  <td className="border p-2 font-normal text-medium"></td>
                </tr>
              </tfoot>
            </table>
          </div>
        </ScrollWrapper>
      </Loadercomponent>
    </Header>
  );
};

export default TransferReports;